module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_c('div', {
    staticClass: "bg_box"
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('van-swipe', {
    attrs: {
      "autoplay": 3000,
      "show-indicators": false
    }
  }, _vm._l((_vm.bannerData), function(item, index) {
    return _c('van-swipe-item', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('van-image', {
      attrs: {
        "width": "100%",
        "height": "100%",
        "fit": "cover",
        "lazy-load": "",
        "src": item.image
      },
      scopedSlots: _vm._u([{
        key: "error",
        fn: function() {
          return [_vm._v("加载失败")]
        },
        proxy: true
      }], null, true)
    })], 1)])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "index_box"
  }, [_c('div', {
    staticClass: "typelist_box"
  }, _vm._l((_vm.typeData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "typelist",
      on: {
        "click": function($event) {
          return _vm.changetype(item.id)
        }
      }
    }, [_c('van-image', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "examlist_box"
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了",
      "immediate-check": false
    },
    on: {
      "load": _vm.getExamList
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "examlist",
      on: {
        "click": function($event) {
          return _vm.gotodetail(item.id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n        ")])
  }), 0)], 1)]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-58f0baee"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/typelist.vue
// module id = 698
// module chunks = 1